RewardedVideoToolbarItem.REWARD_CURRENCY = "soft";

Reward.TIME_VALUE_PRICE_PER_HOUR = 4;
Reward.LIVES_PRICE = 33;
